import { formatCPF } from '@brazilian-utils/brazilian-utils';

// Item de `toRemove` da prévia de POST /chains/{chainId}/tag/{id}/import-cpfs (pontuax-backend src/api/tag/cpf-import.ts).
// Sem a permissão "Listar clientes" o backend manda só o id: nome e CPF vêm nulos (pedido ao dev #8).
export interface TagRemovalItem {
  customerId: string;
  name: string | null;
  cpf: string | null;
}

/**
 * Linhas "Nome · CPF" de quem sai da etiqueta, ou `null` quando o backend escondeu quem são.
 * Com `null` a tela mostra só a quantidade: o operador decide pela planilha, sem ver clientes.
 * `noName` vem traduzido de quem chama (`__t('Sem nome')`).
 */
export function removalLines(toRemove: TagRemovalItem[], noName: string): string[] | null {
  if (toRemove.some(r => !r.cpf)) { return null; }
  return toRemove.map(r => `${r.name || noName} · ${formatCPF(r.cpf as string)}`);
}
